var _rect, _circle, _circle2, _path, _path2, _text, _text2, _path3, _rect2, _circle3, _path4, _path5, _text3, _text4, _rect3, _circle4, _path6, _text5, _text6, _rect4, _circle5, _rect5, _path7, _text7, _text8, _rect6, _circle6, _circle7, _path8, _text9, _text0, _rect7, _circle8, _text1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkPassportRoleBasedControlAccountabilityMapDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1400,
    height: 700,
    viewBox: "0 0 1400 700",
    role: "img",
    "aria-label": "Role-based control desktop map",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1400,
    height: 700,
    rx: 38,
    fill: "#07152A",
    stroke: "#29405D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 328,
    r: 137,
    fill: "#087CFF",
    fillOpacity: 0.09,
    stroke: "#1B5FA8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 328,
    r: 83,
    fill: "#0B1D35",
    stroke: "#30D6A1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M700 283.8l16.8 6v12c0 10.799999999999999-7.199999999999999 18-16.8 22.8-16.8-4.8-16.8-12-16.8-22.8v-12z",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M691.6 303l6 6 12-13.2",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 700,
    y: 365,
    textAnchor: "middle",
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 19,
    fontWeight: 850
  }, "WORK PASSPORT")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 700,
    y: 391,
    textAnchor: "middle",
    fill: "#9AB0CA",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 11,
    fontWeight: 700
  }, "GOVERNED SOURCE")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M565 270L386 188M835 270l179-82M565 385L386 500M835 385l179 115",
    stroke: "#29405D",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 84,
    width: 310,
    height: 178,
    rx: 25,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 138,
    r: 30,
    fill: "#087CFF",
    fillOpacity: 0.12
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128 126.16l10.36 3.7v7.4c0 6.66-4.4399999999999995 11.1-10.36 14.06-10.36-2.96-10.36-7.4-10.36-14.06v-7.4z",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.776,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.82 138l3.7 3.7 7.4-8.14",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.776,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 106,
    y: 195,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 21,
    fontWeight: 850
  }, "Compliance teams")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 106,
    y: 224,
    fill: "#9AB0CA",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 650,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 106,
    dy: 0
  }, "Requirements, evidence"), /*#__PURE__*/React.createElement("tspan", {
    x: 106,
    dy: 20
  }, "and exceptions"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1016,
    y: 84,
    width: 310,
    height: 178,
    rx: 25,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1070,
    cy: 138,
    r: 30,
    fill: "#30D6A1",
    fillOpacity: 0.12
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1059.64 147.62v-19.98h20.72v19.98M1064.82 132.82h2.2199999999999998m3.7 0h2.2199999999999998m3.7 0h2.2199999999999998M1057.42 147.62h25.16",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 1.776,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 1048,
    y: 195,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 21,
    fontWeight: 850
  }, "Operations managers")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 1048,
    y: 224,
    fill: "#9AB0CA",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 650,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1048,
    dy: 0
  }, "Deployment readiness"), /*#__PURE__*/React.createElement("tspan", {
    x: 1048,
    dy: 20
  }, "before allocation"))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 432,
    width: 310,
    height: 178,
    rx: 25,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 486,
    r: 30,
    fill: "#F5AE35",
    fillOpacity: 0.12
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 117.64,
    y: 477.12,
    width: 20.72,
    height: 18.5,
    rx: 2.2199999999999998,
    fill: "none",
    stroke: "#F5AE35",
    strokeWidth: 1.776,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.64 483.04h20.72M122.82 474.16v5.18M133.18 474.16v5.18",
    fill: "none",
    stroke: "#F5AE35",
    strokeWidth: 1.776,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 106,
    y: 543,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 21,
    fontWeight: 850
  }, "Training coordinators")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 106,
    y: 572,
    fill: "#9AB0CA",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 650,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 106,
    dy: 0
  }, "Cohorts, dates and"), /*#__PURE__*/React.createElement("tspan", {
    x: 106,
    dy: 20
  }, "delivery status"))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1016,
    y: 432,
    width: 310,
    height: 178,
    rx: 25,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1070,
    cy: 486,
    r: 30,
    fill: "#F54291",
    fillOpacity: 0.12
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1070,
    cy: 479.34,
    r: 4.4399999999999995,
    fill: "none",
    stroke: "#F54291",
    strokeWidth: 1.776,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1060.38 496.36c0-8.879999999999999 19.24-8.879999999999999 19.24 0",
    fill: "none",
    stroke: "#F54291",
    strokeWidth: 1.776,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 1048,
    y: 543,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 21,
    fontWeight: 850
  }, "Employees")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 1048,
    y: 572,
    fill: "#9AB0CA",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 650,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1048,
    dy: 0
  }, "Due actions, choices"), /*#__PURE__*/React.createElement("tspan", {
    x: 1048,
    dy: 20
  }, "and digital passport"))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 604,
    width: 440,
    height: 56,
    rx: 18,
    fill: "#10243E"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 632,
    r: 6,
    fill: "#30D6A1"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 538,
    y: 638,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 760
  }, "Human-governed \xB7 Intelligence-assisted")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPassportRoleBasedControlAccountabilityMapDesktop);
export default __webpack_public_path__ + "static/media/work-passport-role-based-control-accountability-map-desktop.6cd8ca485ea0fea407855143e2fc5101.svg";
export { ForwardRef as ReactComponent };